import React, { useContext, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from "@iconify/react";
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";

const DataTable = ({ title, rows, columns, role, onActionClick, onRowClick, options, handleDialogBoxes, totalCount, pagesCount, currentPage, rowsPerPage, onRowsPerPageChange, onPageChange, onStatusChange, eventStatus, categories, category, onCategoryChange, onDateChange, filteredDate, onSearch, searcItem, isArchivedStatus, onToggle, loaderStatus, addButtonTitle,addButtonOnlyOption }) => {
  const { showHeader, showHeaderTwo, viewOption, addOption, editOption, statusFilterOption, dateFilterOption, typeFilterOption, searchOption, archiveFilterOption } = options;
  // const { userData } = useContext(UserDataContext);
  const isAdmin = role === 'admin' ? true : false;
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(eventStatus || "All");

  const [isDateFilterOpen, setIsDateFilterOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(filteredDate || null);

  const [isTypeOpen, setIsTypeOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(category || "Type");

  const [isPaginationOpen, setIsPaginationOpen] = useState(false);
  const [selectedPagination, setSelectedPagination] = useState(rowsPerPage.toString());
  const [isArchived, setIsArchived] = useState(null || isArchivedStatus);
  const [searchTerm, setSearchTerm] = useState(searcItem || '');
  const searchTimeoutRef = useRef(null);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    // Clear previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Set a new timeout to debounce search
    searchTimeoutRef.current = setTimeout(() => {
      onSearch(value);
    }, 500); // Adjust debounce time if needed
  };

  const handleSelect = (status) => {
    if (status === "all") {
      onStatusChange("all")
      setSelected("All");
    } else {
      onStatusChange(status)
      setSelected(status);
    }
    setIsOpen(false); // Close the dropdown
  };

  const handleDateSelect = (date) => {
    onDateChange(date);
    setSelectedDate(date); // Set the selected status
    setIsDateFilterOpen(false); // Close the dropdown
  };

  const handleTypeSelect = (id, name) => {
    onCategoryChange(id);
    setSelectedType(name); // Set the selected status
    setIsTypeOpen(false); // Close the dropdown
  };

  const handlePaginationSelect = (count) => {
    setSelectedPagination(count);
    setIsPaginationOpen(false);
    onRowsPerPageChange(Number(count)); // Notify parent about the change
  };

  const handlePageChange = (pageNumber) => {
    onPageChange(pageNumber); // Notify parent about the current page change
  };

  const toggleArchiveFilter = (status) => {
    setIsArchived(status);
    onToggle(status);
  };

  const handleReset = () => {
    statusFilterOption && setSelected("All");
    dateFilterOption && setSelectedDate(null);
    typeFilterOption && setSelectedType("Type");
    searchOption && setSearchTerm('');
    setSelectedPagination(10);
    archiveFilterOption && setIsArchived(false);

    statusFilterOption && onStatusChange("all");
    dateFilterOption && onDateChange(null);
    typeFilterOption && onCategoryChange(null);
    searchOption && onSearch('');
    onRowsPerPageChange(10);
    onPageChange(1);
    archiveFilterOption && onToggle(false);
  };


  const formatDateTime = (dateTime) =>
    `${new Date(dateTime).toLocaleDateString('en-CA')}`;

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg mb-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between w-full gap-4 mb-4">
        <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
        {addButtonOnlyOption && (
          <button
            onClick={handleDialogBoxes}
            className="w-full sm:w-auto h-10 flex items-center justify-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg text-sm font-medium transition-colors"
          >
            <svg
              className="w-4 h-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
            {addButtonTitle}
          </button>
        )}
        {/* pagination */}
        {showHeaderTwo && (
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex items-center space-x-2 relative">
              <span className="text-gray-600">Show</span>
              <div
                className="relative border border-gray-300 rounded-lg px-4 w-20 h-10 flex items-center justify-between cursor-pointer focus:ring-2 focus:ring-gray-200"
                onClick={() => setIsPaginationOpen((prev) => !prev)}
              >
                <span>{selectedPagination}</span>
                <Icon icon="iconamoon:arrow-down-2-thin" className="text-xl" />
              </div>
              {isPaginationOpen && (
                <ul className="absolute left-12 top-full z-10 bg-white border border-gray-200 rounded-lg mt-1 w-20 shadow-lg max-h-60 overflow-y-auto">
                  {["5", "10", "15", "20", "30", "40", "50"].map((count) => (
                    <li
                      key={count}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-center"
                      onClick={() => handlePaginationSelect(count)}
                    >
                      {count}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            {/* Search Box */}
            {searchOption && (
              <div className="relative w-full sm:w-auto flex-shrink-0">
                <input
                  type="text"
                  placeholder="Search here"
                  value={searchTerm}
                  onChange={handleSearch}
                  className="w-full sm:w-64 md:w-80 h-10 pl-10 pr-4 text-gray-500 placeholder-gray-400 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-100"
                />
                <svg
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            )}

            {/* Add Button */}
            {addOption && (
              <button
                onClick={handleDialogBoxes}
                className="w-full sm:w-auto h-10 flex items-center justify-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg text-sm font-medium transition-colors"
              >
                <svg
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4v16m8-8H4"
                  />
                </svg>
                {addButtonTitle || 'Add New'}
              </button>
            )}
          </div>
        )}
      </div>

      {showHeader && (
        <div className="flex flex-wrap items-center gap-3 py-4 border-t px-4 md:px-6">
          {/* Filters Section (Wraps into multiple rows if needed) */}
          <div className="flex flex-wrap items-center gap-3 flex-grow">
            {/* Pagination Dropdown */}
            <div className="flex items-center space-x-2 relative">
              <span className="text-gray-600">Show</span>
              <div
                className="relative border border-gray-300 rounded-lg px-4 w-20 h-10 flex items-center justify-between cursor-pointer focus:ring-2 focus:ring-gray-200"
                onClick={() => setIsPaginationOpen((prev) => !prev)}
              >
                <span>{selectedPagination}</span>
                <Icon icon="iconamoon:arrow-down-2-thin" className="text-xl" />
              </div>
              {isPaginationOpen && (
                <ul className="absolute left-12 top-full z-10 bg-white border border-gray-200 rounded-lg mt-1 w-20 shadow-lg max-h-60 overflow-y-auto">
                  {["5", "10", "15", "20", "30", "40", "50"].map((count) => (
                    <li
                      key={count}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-center"
                      onClick={() => handlePaginationSelect(count)}
                    >
                      {count}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Search Input */}
            {searchOption && (
              <input
                type="text"
                placeholder="Search here"
                value={searchTerm}
                onChange={handleSearch}
                className="border border-gray-300 rounded-lg px-4 h-10 text-sm focus:ring-2 focus:ring-gray-200 w-48 sm:w-56 md:w-64 lg:w-80"
              />
            )}
            {/* Status Filter Dropdown */}
            {statusFilterOption && (
              <div className="relative min-w-44">
                <div
                  className="border border-gray-300 rounded-lg px-4 h-10 flex items-center justify-between cursor-pointer focus:ring-2 focus:ring-gray-200"
                  onClick={() => setIsOpen((prev) => !prev)}
                >
                  <span>{selected.charAt(0).toUpperCase() + selected.slice(1)}</span>
                  <Icon icon="iconamoon:arrow-down-2-thin" className="text-xl" />
                </div>
                {isOpen && (
                  <ul className="absolute z-10 bg-white border border-gray-200 rounded-lg mt-1 w-full shadow-lg max-h-60 overflow-y-auto">
                    {["all", "paid", "pending", "free"].map((status) => (
                      <li
                        key={status}
                        className={`px-4 py-2 cursor-pointer ${selected === status ? "bg-gray-100 font-semibold" : "hover:bg-gray-100"}`}
                        onClick={() => handleSelect(status)}
                      >
                        {status === "all" ? "All" : status.charAt(0).toUpperCase() + status.slice(1)}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
            {/* Date Picker */}
            {dateFilterOption && (
              <div className="relative min-w-44">
                <div
                  className="border border-gray-300 rounded-lg px-4 h-10 flex items-center justify-between cursor-pointer focus:ring-2 focus:ring-gray-200"
                  onClick={() => setIsDateFilterOpen((prev) => !prev)}
                >
                  <span className='truncate w-full text-left'>{selectedDate ? formatDateTime(selectedDate) : "Date"}</span>
                  <Icon icon="iconamoon:arrow-down-2-thin" className="text-xl" />
                </div>
                {isDateFilterOpen && (
                  <div className="absolute z-10 bg-white border border-gray-200 rounded-lg mt-1 w-full shadow-lg">
                    <Datetime
                      timeFormat={false}
                      input={false}
                      closeOnSelect={true}
                      onChange={(date) => handleDateSelect(formatDateTime(date))}
                      value={selectedDate}
                    />
                  </div>
                )}
              </div>
            )}
            {/* Type Filter */}
            {typeFilterOption && (
              <div className="relative min-w-44">
                <div
                  className="border border-gray-300 rounded-lg px-4  h-10 flex items-center justify-between cursor-pointer focus:ring-2 focus:ring-gray-200"
                  onClick={() => setIsTypeOpen((prev) => !prev)}
                >
                  <span className='truncate w-full text-left'>{selectedType}</span>
                  <Icon icon="iconamoon:arrow-down-2-thin" className="text-xl" />
                </div>
                {isTypeOpen && (
                  <ul className="absolute z-10 bg-white border border-gray-200 rounded-lg mt-1 w-full shadow-lg max-h-60 overflow-y-auto">
                    {categories?.map((type) => (
                      <li
                        key={type.id}
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => handleTypeSelect(type.id, type.name)}
                      >
                        {type.name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
          {/* Archive Filter & Reset Section */}
          <div className="flex flex-wrap items-center space-x-2 mt-3 md:mt-0">
            {/* Archive Filter Buttons */}
            {archiveFilterOption && (
              <div className="flex space-x-2 mr-1">
                {/* <button
                  onClick={() => toggleArchiveFilter(null)}
                  className={`px-3 py-2 rounded-lg ${isArchivedStatus === null ? "text-white bg-blue-500" : "hover:bg-gray-100"}`}
                >
                  All
                </button> */}
                <button
                  onClick={() => toggleArchiveFilter(false)}
                  className={`px-3 py-2 rounded-lg ${isArchivedStatus === false ? "text-white bg-green-500" : "hover:bg-gray-100"}`}
                >
                  Active
                </button>
                <button
                  onClick={() => toggleArchiveFilter(true)}
                  className={`px-3 py-2 rounded-lg ${isArchivedStatus === true ? "text-white bg-amber-500" : "hover:bg-gray-100"}`}
                >
                  Inactive
                </button>
              </div>
            )}
            {/* Reset Button */}
            <button onClick={() => handleReset()} className="ml-auto" title="Reset Filters" >
              <Icon icon="carbon:filter-reset" className="h-8 w-8 p-1 text-gray-900 rounded-lg hover:bg-gray-200" />
            </button>
          </div>
        </div>
      )}

      <div className="overflow-x-auto border-t">
        <table className="mt-6 w-full text-left border rounded-lg border-gray-200 min-w-max">
          <thead>
            <tr className="bg-gray-100 border-b border-gray-200">
              {columns.map((column) => (
                <th key={column.key} className="px-4 py-4 font-medium">
                  {column.label}
                </th>
              ))}
              {onActionClick && <th className="px-4 py-4">Actions</th>}
            </tr>
          </thead>
          <tbody>
            {loaderStatus ? (
              Array.from({ length: 5 }).map((_, idx) => (
                <tr key={`skeleton-${idx}`} className="animate-pulse border-b border-gray-200">
                  {columns.map((column, i) => (
                    <td key={`skeleton-cell-${i}`} className="px-4 py-4">
                      <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                    </td>
                  ))}
                  {onActionClick && (
                    <td className="px-4 py-4">
                      <div className="h-6 w-16 bg-gray-200 rounded"></div>
                    </td>
                  )}
                </tr>
              ))
            ) : rows.length <= 0 ? (
              <tr>
                <td colSpan={columns.length} className="text-center py-4 text-gray-500">
                  No {title} Available...
                </td>
              </tr>
            ) : (
              rows.map((row, index) => (
                <tr key={index}
                  className="border-b border-gray-200 hover:bg-gray-50 cursor-pointer"
                  onClick={onRowClick ? (e) => {
                    e.stopPropagation();
                    onRowClick(row?.registrationId, row?.eventId);
                  } : undefined}
                >
                  {columns.map((column) => (
                    <td key={column.key} className="px-4 py-4">
                      {column.render ? column.render(row) : row[column.key]}
                    </td>
                  ))}
                  {onActionClick && (
                    <td className="px-4 py-2">
                      <div className="flex items-center gap-2.5">
                        {!isArchived && viewOption && (
                          <button
                            disabled={isArchivedStatus}
                            className={`transition ${isArchivedStatus && 'cursor-not-allowed'}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              onActionClick(row.id, 'view');
                            }}
                            title="View"
                          >
                            <Icon icon="hugeicons:view" className="h-7 w-7 px-1 text-2xl text-[#487FFF] bg-[#487FFF] bg-opacity-15 rounded-full hover:bg-opacity-45 hover:text-blue-700" />
                          </button>
                        )}
                        {!isArchived && editOption && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              onActionClick(row.id, 'edit');
                            }}
                            disabled={isArchivedStatus || (title === 'Venues' && !isAdmin)}
                            className={`transition disabled:cursor-not-allowed`}
                            title="Edit"
                          >
                            <Icon icon="uil:edit" className="h-7 w-7 px-1 text-2xl text-[#45B369] bg-[#45B369] bg-opacity-15 rounded-full hover:bg-opacity-45 hover:text-green-700" />
                          </button>
                        )}
                        {archiveFilterOption && isArchivedStatus !== null && isAdmin && (
                          <button
                            title={isArchivedStatus ? 'Activate' : 'Inactivate'}
                            onClick={(e) => {
                              e.stopPropagation();
                              onActionClick(row.id, isArchivedStatus ? 'unarchive' : 'archive');
                            }}>
                            <Icon
                              icon={isArchivedStatus ? 'system-uicons:unarchive' : 'ion:archive-outline'}
                              className="h-7 w-7 px-1 text-2xl text-[#EF4A00] bg-[#F86624] bg-opacity-15 rounded-full hover:bg-opacity-45 hover:text-orange-700"
                            />
                          </button>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
        <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
          <div>
            <p className="text-sm text-gray-700">
              Showing
              {/* <span className="font-medium">1</span>
              to */}
              <span className="font-medium ml-1 mr-1">{rowsPerPage}</span>
              of
              <span className="font-medium ml-1 mr-1">{totalCount}</span>
              results
            </p>
          </div>
          <div>
            <div
              className="isolate inline-flex -space-x-px rounded-md shadow-sm"
              aria-label="Pagination"
            >
              {/* Previous Button */}
              <button
                onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
              >
                <span className="sr-only">Previous</span>
                <svg
                  className="size-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>

              {/* Dynamically Generated Page Buttons */}
              {Array.from({ length: pagesCount }, (_, index) => {
                const page = index + 1;
                return (
                  <button
                    key={page}
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePageChange(page);
                    }}
                    aria-current={currentPage === page ? "page" : undefined}
                    className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${currentPage === page
                      ? "z-10 bg-indigo-600 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      : "text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                      }`}
                  >
                    {page}
                  </button>
                );
              })}

              {/* Next Button */}
              <button
                onClick={() => currentPage < pagesCount && handlePageChange(currentPage + 1)}
                className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
              >
                <span className="sr-only">Next</span>
                <svg
                  className="size-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

// Prop Validation
DataTable.propTypes = {
  /** Array of data objects to populate rows */
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string.isRequired,
  role: PropTypes.string,

  /** Array of column definitions for rendering */
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired, // Key corresponding to data object field
      label: PropTypes.string.isRequired, // Header label for the column
      render: PropTypes.func, // Optional custom renderer for the column
    })
  ).isRequired,

  options: PropTypes.objectOf(
    PropTypes.shape({
      showHeader: PropTypes.bool.isRequired,
      showHeaderTwo: PropTypes.bool.isRequired,
      viewOption: PropTypes.bool.isRequired,
      addOption: PropTypes.bool.isRequired,
      statusFilterOption: PropTypes.bool.isRequired,
      dateFilterOption: PropTypes.bool.isRequired,
      typeFilterOption: PropTypes.bool.isRequired,
      searchOption: PropTypes.bool.isRequired,
      archiveFilterOption: PropTypes.bool.isRequired,
      editOption: PropTypes.bool.isRequired,
    })
  ).isRequired,

  totalCount: PropTypes.number,
  currentPage: PropTypes.number,
  rowsPerPage: PropTypes.number,
  onRowsPerPageChange: PropTypes.func,
  onPageChange: PropTypes.func,
  pagesCount: PropTypes.number,
  onStatusChange: PropTypes.func,
  eventStatus: PropTypes.string,
  categories: PropTypes.array,
  category: PropTypes.string,
  onCategoryChange: PropTypes.func,
  onDateChange: PropTypes.func,
  filteredDate: PropTypes.string,
  onSearch: PropTypes.func,
  searcItem: PropTypes.string,
  onToggle: PropTypes.func,
  isArchivedStatus: PropTypes.bool,
  loaderStatus: PropTypes.bool,
  addButtonTitle: PropTypes.string,
  addButtonOnlyOption: PropTypes.bool,
  // category: PropTypes.string,

  /** Optional function to handle actions on rows */
  onActionClick: PropTypes.func,
  handleDialogBoxes: PropTypes.func,
  onRowClick: PropTypes.func,
};

DataTable.defaultProps = {
  onActionClick: null,
  handleDialogBoxes: null,
};

export default DataTable;



